import { APP_ROUTES } from '@/constants/pages';
import DealsSearchPreview from '@/pages/deals-sok/index';
import SERP from '@/pages/list';
import { RouteComponentProps } from 'react-router-dom';
import UnifiedSearchPage from './UnifiedSearchPage';
import { getSerpTabFromPath } from './unifiedSearch.urls';
import { useSerpTabsVariant } from './useSerpTabsVariant';

const REGULAR_SERP_PATHS: string[] = [APP_ROUTES.SERP_NO_INDEX, APP_ROUTES.SERP];

/**
 * One component for every search results route, so a tab switch between `/:q/:location` and
 * `/sistaminuten/...` keeps the tabbed page mounted. Control, and the Deals and brand pages in
 * both arms, render today's page for the route.
 */
const SearchResultsRoute = (props: RouteComponentProps) => {
  const variant = useSerpTabsVariant();

  if (variant === 'tabbed' && getSerpTabFromPath(props.location.pathname)) {
    return <UnifiedSearchPage />;
  }

  return REGULAR_SERP_PATHS.includes(props.match.path) ? <SERP type="default" /> : <DealsSearchPreview {...props} />;
};

export default SearchResultsRoute;
